/**
 * Startup feedback (investor → startup when removing from favorites).
 * Anonymous: startup sees only investor country.
 *
 * Firestore: collection name and field names for Cloud Functions.
 */

export const STARTUP_FEEDBACK_COLLECTION = 'startupFeedback' as const;

export const STARTUP_FEEDBACK_FIELDS = {
  startupId: 'startupId',
  investorCountry: 'investorCountry',
  reasons: 'reasons',
  otherReason: 'otherReason',
  createdAt: 'createdAt',
} as const;

/** Reason codes stored in Firestore; used in API and UI. */
export const STARTUP_FEEDBACK_REASON_CODES = [
  'not_enough_traction',
  'team_not_strong',
  'bad_timing',
  'too_competitive',
  'needs_more_capital',
  'other',
] as const;

import type { StartupFeedbackReasonCode } from '../types/firestore';

/** Display labels for feedback reasons (modal checkboxes). */
export const STARTUP_FEEDBACK_REASON_LABELS: Record<StartupFeedbackReasonCode, string> = {
  not_enough_traction: 'Not enough traction',
  team_not_strong: 'Team not strong enough',
  bad_timing: 'Bad timing for this idea or market',
  too_competitive: 'Landscape is too competitive',
  needs_more_capital: 'Much higher capital would be needed to succeed',
  other: 'Other reason',
};
